class HeroBannerSlider extends HTMLElement {
  connectedCallback() {
    // Swiper itself is fetched lazily (see layout/theme.liquid) so it
    // doesn't block initial page load. Until it's ready, CSS alone keeps
    // just the first slide visible (see the .hero-banner--not-initialized
    // rule in this section's <style> block).
    if (typeof Swiper !== 'undefined') {
      this.initSwiper();
    } else {
      this.onSwiperLoaded = this.initSwiper.bind(this);
      document.addEventListener('swiper:loaded', this.onSwiperLoaded, { once: true });
    }
  }

  initSwiper() {
    if (this.swiper) return;

    const autoplayDelay = Number(this.dataset.autoplayDelay);
    const paginationEl = this.querySelector('.swiper-pagination');
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');

    this.swiper = new Swiper(this, {
      effect: this.dataset.effect || 'slide',
      loop: this.dataset.loop === 'true',
      speed: 600,
      autoHeight: true,
      autoplay: autoplayDelay
        ? { delay: autoplayDelay, disableOnInteraction: false }
        : false,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      on: {
        init: () => {
          this.classList.remove('hero-banner--not-initialized');
          this.updateVideoPlayback();
        },
        slideChangeTransitionEnd: () => this.updateVideoPlayback(),
      },
    });
  }

  updateVideoPlayback() {
    this.querySelectorAll('.hero-banner__video').forEach((video) => {
      const slide = video.closest('.swiper-slide');
      if (slide && slide.classList.contains('swiper-slide-active')) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  disconnectedCallback() {
    if (this.onSwiperLoaded) {
      document.removeEventListener('swiper:loaded', this.onSwiperLoaded);
    }
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

customElements.define('hero-banner-slider', HeroBannerSlider);
